import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
import { countListingsByFilters } from '../SearchPage/SearchPage.duck';
import { fetchPageTranslations } from '../../containers/EditTranslationsPage/EditTranslationsPage.duck';
export const ASSET_NAME = 'landing-page';

export const loadData = (params, search) => dispatch => {
  dispatch(countListingsByFilters({ queryParams: {} }));

  const pageAsset = { landingPage: `content/pages/${ASSET_NAME}.json` };

  const promises = [
    dispatch(fetchPageAssets(pageAsset, true)),
    dispatch(fetchPageTranslations(ASSET_NAME)),
  ]

  return Promise.all(promises);
};
